// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__nCrk1","title":"Navbar_title__T7MOj","btn":"Navbar_btn__U+Axc","svg":"Navbar_svg__ATVEO","home":"Navbar_home__kDlq9"};